import Big from 'big.js'

export const transformValueWithDecimals = (amount: Big, decimals: number): Big => {
  return amount.mul(1 / 10 ** decimals)
}
